module.exports = __webpack_public_path__ + "img/WechatIMG797.e057e3de.png";